<template>
  <div class="container">
    <div class="buttons" v-show="show_new_pensum">
      <div
        class="button is-info"
        v-for="(pensum, pidx) in pensums"
        :key="pidx"
        @click="select_pensum(pensum)"
      >
        <span class="icon"><i class="fa fa-book"></i></span>
        <span>{{ pensum.name }}</span>
      </div>
      <div class="button is-primary" @click="create_pensum">
        <span class="icon"><i class="fa fa-plus"></i></span>
        <span>{{ $t("new pensum") }}</span>
      </div>
    </div>
    <pensum
      ref="pensum"
      v-show="show_pensum"
      @success="init_state"
      @cancel="init_state"
    />
  </div>
</template>

<script>
import { get } from "@/utils";
import Pensum from "./Pensum.vue";

export default {
  name: "ProgramPensums",
  data() {
    return {
      pensums: [],
      selected_pensum: {},
      show_pensum: false,
      show_new_pensum: false,
      program_uuid: undefined,
    };
  },
  components: { Pensum },
  methods: {
    refresh_pensums(program) {
      let v = this;
      v.show_new_pensum = true;
      v.show_pensum = false;
      v.$refs.pensum.init_state();
      v.pensums = [];
      v.program_uuid = program.uuid;
      v.$refs.pensum.set_program(program.program_id);
      v.refresh();
    },
    select_pensum(pensum) {
      this.selected_pensum = pensum;
      this.$refs.pensum.set_pensum(pensum);
      this.show_pensum = true;
      this.show_new_pensum = false;
    },
    create_pensum() {
      this.show_new_pensum = false;
      this.show_pensum = true;
    },
    init_state() {
      this.show_pensum = false;
      this.show_new_pensum = true;
      this.refresh();
    },
    refresh() {
      let v = this;
      get("/student/pensum/program", { uuid: v.program_uuid })
        .then((pensums) => {
          v.pensums = pensums;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.menu a.is-active {
  background-color: #00d1b2;
  color: white;
}
</style>
